var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTick = function SvgTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#2A7776",
    cx: 9,
    cy: 9,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.355 5a.802.802 0 0 0-.258.045c-2.651.898-4.875 3.078-5.849 5.576A6.57 6.57 0 0 0 5.127 9.04a.817.817 0 0 0-.353-.084c-.68 0-1.13.93-.398 1.28 1.18.565 1.926 1.334 2.523 2.43.122.225.384.334.646.334.328 0 .656-.171.713-.5.45-2.6 2.525-5.2 5.234-6.118.804-.272.574-1.382-.137-1.382Z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
};
export default SvgTick;